import React from 'react';
import Login from './Login';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { loginUser } from '../../../../actions/security';
import * as qs from 'qs';
import history from '../../../../history';

class LoginContainer extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            login: '',
            password: '',
            error: null,
            ssoError: null,
        };
    }

    componentDidMount() {
        const queryParams = qs.parse(history.location.search.slice(1));
        this.setState({ login: queryParams.username || '' });

        // The API sends failed UpFresh SSO attempts back to the web app root
        // with ?sso_error=1 (UpFreshSsoController). Tell the user what happened
        // and leave them on the form so they can sign in by hand.
        //
        // The flag deliberately stays in the URL: CacheBuster hard-reloads the
        // page on a first visit and after every version bump, and it does so
        // after this runs, so anything stripped here would take the message
        // with it. Submitting the form clears the message instead.
        if (queryParams.sso_error) {
            this.setState({
                ssoError: <FormattedMessage id="security.sso_error" />,
            });
        }
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            error: nextProps.serverErrors,
        });
    }

    handleLogin = async (e) => {
        e.preventDefault();

        this.setState({ ssoError: null });

        this.props.loginUser({
            login: this.state.login,
            password: this.state.password,
        });
    };

    handleOnChange = (event) => {
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value,
        });
    };

    render() {
        return (
            <Login
                login={this.state.login}
                password={this.state.password}
                error={this.state.error || this.state.ssoError}
                loading={this.props.loading}
                onChange={this.handleOnChange}
                handleLogin={this.handleLogin}
            />
        );
    }
}

const mapStateToProps = (state) => {
    return {
        serverErrors: state.apiErrors.security,
        loading: state.loadingState.loading,
    };
};

export default connect(mapStateToProps, { loginUser: loginUser })(
    LoginContainer
);
